import { render, staticRenderFns } from "./GenericField.vue?vue&type=template&id=5aff32df&scoped=true&"
import script from "./GenericField.vue?vue&type=script&lang=js&"
export * from "./GenericField.vue?vue&type=script&lang=js&"
import style0 from "./GenericField.vue?vue&type=style&index=0&id=5aff32df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aff32df",
  null
  
)

export default component.exports